import react, { useState,useEffect } from "react"
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Bottomstrip from "./Bottomstrip";
import './custome.css'
import Axios from "axios";
import thankyou from '../thankyou.png'
import MuiAlert from "@material-ui/lab/Alert";



function Alert(props) {
    return <MuiAlert elevation={6}
        variant="filled" {...props} />;
}

export default function Conclude() {

    const [customernumber, Setcustomernumber] = useState('')
    const [mpin, Setmpin] = useState()
    const [topupamt, Settopupamt] = useState(0)
    const [balanceamt, Setbalanceamt] = useState()
    const [transactionlist,Settransactinlist]=useState([])

    const agentNumber = localStorage.getItem('AgentNumber')
    const [rechargesuccessful, isrechargesuccessful] = useState(false)
    const [lowbalance, islowbalance] = useState(false)

    const [rechargefailed, isrechargefailed] = useState(false)

    function recharge() {
        let data = { customernumber, mpin, topupamt, agentNumber }
        let amount = data.topupamt*1000
        console.log("Data===>>", data)

        if(data.topupamt>balanceamt){
            console.log("Recharge Amount is big")
            islowbalance(true)
        }
        else{
            const req = Axios.get("https://ekyc.chili.mu:9443/api/eTopup?msisdn=230" + data.customernumber + "&agentNbr=" + data.agentNumber + "&amount=" + amount + "&operChannelId=15&agentPwd=" + data.mpin,
            {
                headers: { 'Content-Type': 'application/json; charset=utf-8' }
            }).then((res) => {
                console.log("result is ", res.data.status)
                isrechargefailed(false)
                    islowbalance(false)
                isrechargesuccessful(true)
                window.location.replace("/choosecustomer")

            }).catch((error) => {
                console.log(error);
                isrechargefailed(true)
                isrechargesuccessful(false)
                islowbalance(false)
            });

        }

        
    }

    const getBalance=async()=>{
        try {
            const url = "https://ekyc.chili.mu:9443/api/last5transactions?msisdn=230" + "&agentNbr=" + localStorage.getItem('AgentNumber')+ "&mPin=" + localStorage.getItem('agentpin');
      
            const response = await Axios.get(url);
            let datacount = response.data?.data[0] || {}                              
            console.log("data--->>",datacount.dealerBalAfter/1000)
            Setbalanceamt(datacount.dealerBalAfter/1000);      
          } catch (error) {      
            console.error("API error:", error);      
            Setbalanceamt({});      
          }        
    }

    useEffect(() => {    
        getBalance();     
      }, []);

    return (
        <div className="Auth-container" style={{ textAlign: 'center' }}>

            {rechargefailed == true && (
                <div style={{ marginTop: -20, marginLeft: 30 }}>
                    <Alert severity="error">Recharge Failed. Please try Later..</Alert>
                </div>
            )}
            {rechargesuccessful == true && (
                <div style={{ marginTop: -20, marginLeft: 30 }}>
                    <Alert severity="success">Recharge Successful. Please proceed </Alert>
                </div>
            )}
            {lowbalance == true && (
                <div style={{ marginTop: -20, marginLeft: 30 }}>
                    <Alert severity="error">You have insufficient Balance </Alert>
                </div>
            )}

            <h4
                style={{
                    textAlign: 'center',
                    color: '#f049ac',
                    marginLeft: 20,
                    marginTop: 20,
                }}>e-TopUp
            </h4>
            <h6>Please Enter Customer MSISDN</h6>
            <h5
                style={{
                    textAlign: 'center',
                    color: '#f049ac',
                    marginLeft: 20,
                    marginTop: 20,
                }}>
                    Your Balance is MUR {balanceamt}
            </h5>
            <TextField
                name="msisdn"
                type="tel"
                id="outlined-required"
                label={<div>MSISDN</div>}
                variant="outlined"
                inputProps={{ maxLength: 8 }}
                onChange={(e) => Setcustomernumber(e.target.value)}
            />
            <br></br>
            <br></br>
            <TextField
                name="amount"
                type="number"
                id="outlined-required"
                label={<div>Amount</div>}
                variant="outlined"
                inputProps={{ maxLength: 4 }}
                onChange={(e) => Settopupamt(e.target.value)}
            />
            <br></br>
            <br></br>

            {topupamt != 0 && customernumber.trim().length == 8 ?
                <div>
                    <TextField
                        name="MPIN"
                        type="number"
                        id="outlined-required"
                        label={<div>MPIN</div>}
                        variant="outlined"
                        inputProps={{ maxLength: 4 }}
                        onChange={(e) => Setmpin(e.target.value)}
                    />
                    <br></br>
                    <br></br>
                    <button className="button_id" style={{ fontSize: 16, width: 120, padding: 10 }}
                        onClick={() => recharge()}> Recharge
                    </button>
                    <Link to='/choosecustomer'>
                    <button className="button_id" style={{ fontSize: 16, width: 120, padding: 10 }}
                        > Back
                    </button>
                    </Link>
                </div>
                : <Link to='/choosecustomer'>
                <button className="button_id" style={{ fontSize: 16, width: 120, padding: 10 }}
                    > Back
                </button>
                </Link>
            }
        </div>
    )




}